import { render, staticRenderFns } from "./Owner.vue?vue&type=template&id=da0c74b6&scoped=true&"
import script from "./Owner.vue?vue&type=script&lang=js&"
export * from "./Owner.vue?vue&type=script&lang=js&"
import style0 from "./Owner.vue?vue&type=style&index=0&id=da0c74b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0c74b6",
  null
  
)

export default component.exports